import React, { useEffect, useState } from 'react';
import { SuperAdminTable } from '../../../baseComponents/Table';
import {
  ActionMenuIcon,
  BinIcon,
  EditAppointmentIcon,
  PlusIcon,
} from 'src/icons';
import { Button } from '../../../baseComponents';
import { Dropdown, Menu, Select, Tooltip } from 'antd';
import { Sort } from 'src/icons/Sort.icon';
import AddNewPromptoverrides from './AddNewPromptoverrides';
import { getAllConditionListAction } from 'src/modules/SuperAdmin/store/actions';
import { useDispatch } from 'react-redux';
import EditPromptoverrides from './EditPromptoverrides';
import { useSelector } from 'react-redux';
import {
  getFilterPromptOverride,
  getPromptoverrideByIdAction,
} from 'src/modules/SuperAdmin/store/actions/promptoverrides.action';
import {
  getAllPromptsScreens,
  getLLmVersiosnsActions,
} from 'src/modules/SuperAdmin/store/actions/prompts.action';
import DeletePromptOverrides from './DeletePromptOverrides';
import { getAllActiveOrganizationAction } from 'src/modules/SuperAdmin/store/actions/organization.action';
import { getFromStorage } from '../../../../../../lib/storage';
import organizationEventEmitter from '../../../../../../utilities/organizationEmmiter';

const PromptOverridespage = () => {
  const dispatch = useDispatch();
  const { isLoading, conditionsDropdown } = useSelector(
    (state) => state?.conditionState
  );
  const { AllOverridesList } = useSelector(
    (state) => state?.promptOverrideState
  );
  const { getActiveOrganizationsList } = useSelector(
    (state) => state?.organizationState
  );
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const [conditionOptions, setConditionOptions] = useState([]);
  const [tableData, setTableData] = useState(null);
  const [tableLoader, setTableLoader] = useState(false);
  const [promptoverrideOpen, setPromptoverrideOpen] = useState(false);
  const [editPromptModalOpen, setEditPromptModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [organizationName, setOrganizationName] = useState(null);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [selectedCondition, setSelectedCondition] = useState(null);

  const [selectedOrganizationUUID, setSelectedOrganizationUUID] = useState(
    () => {
      const savedOrg = getFromStorage('superAdminSelectedOrganization');
      const parsedSavedOrg = savedOrg ? JSON.parse(savedOrg) : null;
      return parsedSavedOrg?.org_uuid || currentPractitioner?.org_uuid || null;
    }
  );

  const [organization, setOrganization] = useState(currentPractitioner?.org_id);

  useEffect(
    (id) => {
      dispatch(getFilterPromptOverride(selectedOrganizationUUID, null));
      dispatch(getAllConditionListAction());
      dispatch(getLLmVersiosnsActions());
      dispatch(getAllActiveOrganizationAction());
      dispatch(getAllPromptsScreens());
    },
    [dispatch]
  );

  useEffect(() => {
    setTableLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (conditionsDropdown && Array.isArray(conditionsDropdown)) {
      const dataArr = conditionsDropdown.map((key) => ({
        value: key?.condition_id,
        label: key?.condition_name,
      }));
      dataArr.unshift({ label: 'All', value: null });
      setConditionOptions(dataArr);
    }
  }, [conditionsDropdown]);

  const handleEditprompt = (prompt_override_id) => {
    dispatch(
      getPromptoverrideByIdAction(
        prompt_override_id,
        setEditPromptModalOpen,
        selectedOrganizationUUID
      )
    );
  };

  const handleDeleteOpen = (prompt_override_id) => {
    dispatch(
      getPromptoverrideByIdAction(
        prompt_override_id,
        setDeleteModalOpen,
        selectedOrganizationUUID
      )
    );
  };

  useEffect(() => {
    if (
      getActiveOrganizationsList &&
      Array.isArray(getActiveOrganizationsList)
    ) {
      let dataArr = [];
      getActiveOrganizationsList.forEach((key, index) => {
        dataArr.push({
          value: key?.org_id,
          label: key?.org_name,
          org_uuid: key?.org_uuid,
        });
      });
      setOrganizationOptions(dataArr);
    }
  }, [getActiveOrganizationsList]);

  useEffect(() => {
    if (AllOverridesList) {
      const mappedData = AllOverridesList.map((item) => ({
        prompt_override_id: item.prompt_override_id,
        practitioner_name: item.practitioner_name,
        condition_name: item.condition_name,
        prompt: item.prompt_override,
        description: item.description,
        org_name: item.org_name,
      }));
      setTableData(mappedData);
    }
  }, [AllOverridesList]);

  const menu_options = (prompt_override_id, record) => {
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'editprompt') {
            handleEditprompt(prompt_override_id);
          }

          if (key === 'deleteCondition') {
            handleDeleteOpen(prompt_override_id, record);
          }
        }}
      >
        <Menu.Item key="editprompt">
          <div className="dropdown-text flex items-center space-x-2">
            <EditAppointmentIcon /> <span>Edit prompt override</span>
          </div>
        </Menu.Item>
        <Menu.Item key="deleteCondition">
          <div className="dropdown-text flex items-center space-x-2">
            <BinIcon /> <span>Remove prompt override</span>
          </div>
        </Menu.Item>
      </Menu>
    );
  };

  const practitioner_nameSorter = (a, b) => {
    return a.practitioner_name.localeCompare(b.practitioner_name);
  };

  const condition_nameSorter = (a, b) => {
    return a.condition_name.localeCompare(b.condition_name);
  };

  const description_Sorter = (a, b) => {
    return a.description.localeCompare(b.description);
  };

  useEffect(() => {
    const unsubscribe = organizationEventEmitter.subscribe(
      'organizationChanged',
      (newOrg) => {
        setSelectedOrganizationUUID(newOrg);
        onChangeHandler(null, newOrg, 'organization');
      }
    );
    return () => unsubscribe();
  }, []);

  const onChangeHandler = (e, value, field) => {
    if (field === 'organization') {
      setOrganization(value?.value);
      setOrganizationName(value?.label);
      setSelectedOrganizationUUID(value?.org_uuid);
      if (selectedCondition) {
        dispatch(getFilterPromptOverride(value?.org_uuid, selectedCondition));
      } else {
        dispatch(getFilterPromptOverride(value?.org_uuid, null));
      }
    } else if (field === 'condition') {
      if (value?.label === 'All') {
        setSelectedCondition(null);
        dispatch(getFilterPromptOverride(selectedOrganizationUUID, null));
      } else {
        dispatch(
          getFilterPromptOverride(selectedOrganizationUUID, value?.value)
        );
        setSelectedCondition(value?.value);
      }
    }
  };

  const columns = [
    {
      title: <span className="font-[700]"> Organization</span>,
      dataIndex: 'org_name',
      key: 'org_name',
      width: '22%',
    },
    {
      title: (
        <span className="font-[700]">
          {' '}
          Practitioner name{' '}
          {tableData?.length > 0 && <Sort className={'sort-icon-doctor'} />}
        </span>
      ),
      dataIndex: 'practitioner_name',
      key: 'practitioner_name',
      sorter: tableData?.length > 0 && practitioner_nameSorter,
      width: '20%',
    },
    {
      title: (
        <span className="font-[700]">
          {' '}
          Condition name{' '}
          {tableData?.length > 0 && <Sort className={'sort-icon-doctor'} />}
        </span>
      ),
      dataIndex: 'condition_name',
      key: 'condition_name',
      sorter: tableData?.length > 0 && condition_nameSorter,
    },
    {
      title: <span className="font-[700]"> Prompt</span>,
      dataIndex: 'prompt',
      key: 'prompt',
      // sorter: prompt_nameSorter,
      render: (text, record) => {
        const textLength = text.length > 100;
        const tooltipContent = (
          <div
            className={`${textLength ? 'flex w-[495px] overflow-auto whitespace-normal h-60 p-2' : ' '}`}
            style={{ overflowX: 'hidden' }}
          >
            {text}
          </div>
        );
        return (
          <>
            <Tooltip
              title={tooltipContent}
              placement={textLength ? 'top' : 'bottom'}
            >
              <div className="truncate w-56">{text}</div>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: (
        <span className="font-[700]">
          {' '}
          Description{' '}
          {tableData?.length > 0 && <Sort className={'sort-icon-doctor'} />}
        </span>
      ),
      dataIndex: 'description',
      key: 'description',
      sorter: tableData?.length > 0 && description_Sorter,
    },
    {
      title: '',
      key: 'actions',
      dataIndex: 'actions',

      render: (text, record) => {
        return (
          <Dropdown
            className=""
            overlay={menu_options(record?.prompt_override_id)}
          >
            <a className="" onClick={(e) => e.preventDefault()}>
              <ActionMenuIcon />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <div>
      <div className="flex flex-col sm:flex-row lg:justify-between justify-center items-center">
        <div className="flex flex-col sm:flex-row w-full">
          <div className="flex justify-start w-full">
            <div className="  bg-white shadow-sm rounded-xl w-3/5 flex items-center practitioner-dropdown">
              <Select
                style={{
                  placeholder: {
                    fontFamily: 'Poppins',
                    color: '#667085',
                  },
                }}
                bordered={false}
                className="border-none font-sans h-10 flex items-center  focus:outline-none w-full"
                optionFilterProp="label"
                placeholder="Search condition"
                id="search_condition"
                showSearch
                options={conditionOptions}
                onChange={(e, value) => onChangeHandler(e, value, 'condition')}
                value={selectedCondition}
              ></Select>
            </div>
          </div>
        </div>
        <div className="flex justify-end items-end w-80">
          <Button
            type={'button'}
            onClick={() => {
              setPromptoverrideOpen(true);
            }}
          >
            <PlusIcon className={`mr-2`} /> Add prompt override
          </Button>
        </div>
      </div>
      <div>
        <div className="mt-5 ant-table rounded-xl shadow-xl">
          <SuperAdminTable
            className={'appointment-page-table'}
            data={tableData}
            columns={columns}
            loading={tableLoader}
          />
        </div>
      </div>

      {/* All modals constructed here */}
      <AddNewPromptoverrides
        isOpen={promptoverrideOpen}
        setIsOpen={setPromptoverrideOpen}
        selectedOrganizationUUID={selectedOrganizationUUID}
        setSelectedOrganizationUUID={setSelectedOrganizationUUID}
        setOrganizationName={setOrganizationName}
        selectedCondition={selectedCondition}
      />

      <EditPromptoverrides
        isOpen={editPromptModalOpen}
        setIsOpen={setEditPromptModalOpen}
        selectedOrganizationUUID={selectedOrganizationUUID}
        setSelectedOrganizationUUID={setSelectedOrganizationUUID}
        organizationName={organizationName}
        currentPractitioner={currentPractitioner}
        selectedCondition={selectedCondition}
      />

      <DeletePromptOverrides
        isOpen={deleteModalOpen}
        setIsOpen={setDeleteModalOpen}
        selectedOrganizationUUID={selectedOrganizationUUID}
        setSelectedOrganizationUUID={setSelectedOrganizationUUID}
        selectedCondition={selectedCondition}
      />
    </div>
  );
};

export default PromptOverridespage;
